import { render, staticRenderFns } from "./AgendamentoTarefa.vue?vue&type=template&id=8b88888c&lang=html"
import script from "./AgendamentoTarefa.vue?vue&type=script&lang=js"
export * from "./AgendamentoTarefa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports